import { render, staticRenderFns } from "./ShenPiQingJia.vue?vue&type=template&id=6dd33474&scoped=true&"
import script from "./ShenPiQingJia.vue?vue&type=script&lang=js&"
export * from "./ShenPiQingJia.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiQingJia.vue?vue&type=style&index=0&id=6dd33474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd33474",
  null
  
)

export default component.exports